import React from 'react';
import styled from 'styled-components';
import { Square, X } from 'lucide-react';

const ControlsContainer = styled.div`
  display: flex;
  gap: 1px;
  -webkit-app-region: no-drag;
`;

const MinimizeIcon = styled.div`
  width: 10px;
  height: 1px;
  background: currentColor;
  margin-bottom: 1px;
`;

const ControlButton = styled.button`
  width: 46px;
  height: 32px;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease;
  background: transparent;
  color: ${({ theme }) => theme.colors.dark.text};
  
  &.minimize {
    &:hover {
      background: rgba(255, 255, 255, 0.1);
    }
  }
  
  &.maximize {
    &:hover {
      background: rgba(255, 255, 255, 0.1);
    }
  }
  
  &.close {
    &:hover {
      background: #e81123;
      color: white;
    }
  }
  
  svg {
    width: 12px;
    height: 12px;
  }
`;

const WindowControls = () => {
  const handleMinimize = async () => {
    if (window.electronAPI) {
      await window.electronAPI.minimizeWindow();
    }
  };

  const handleMaximize = async () => {
    if (window.electronAPI) {
      await window.electronAPI.maximizeWindow();
    }
  };

  const handleClose = async () => {
    if (window.electronAPI) {
      await window.electronAPI.closeWindow();
    }
  };

  return (
    <ControlsContainer>
      <ControlButton className="minimize" onClick={handleMinimize} title="Minimize">
        <MinimizeIcon />
      </ControlButton>
      <ControlButton className="maximize" onClick={handleMaximize} title="Maximize">
        <Square />
      </ControlButton>
      <ControlButton className="close" onClick={handleClose} title="Close">
        <X />
      </ControlButton>
    </ControlsContainer>
  );
};

export default WindowControls;
